import { useMemo } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';

// project-imports
import FullScreen from './FullScreen';
import MobileSection from './MobileSection';
import Profile from './Profile';
import Search from './Search';
import Localization from './Localization';
import Notification from './Notification';
import WhatsNew from './WhatsNew';
// import MegaMenuSection from './MegaMenuSection';
import useAuth from 'hooks/useAuth';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';

// type
import IconButton from 'components/@extended/IconButton';
import { SUPPORT_WHATSAPP_URL, USE_INTERCOM } from 'config';
import { MessageQuestion, Moon, Sun1 } from 'iconsax-react';
import { MenuOrientation, ThemeMode } from 'types/config';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { i18n, menuOrientation } = useConfig();
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  const { user } = useAuth();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const localization = useMemo(() => <Localization />, [i18n]);

  // const megaMenu = useMemo(() => <MegaMenuSection />, []);

  const { mode, onChangeMode } = useConfig();

  const handleModeChange = () => {
    if (mode === ThemeMode.LIGHT) {
      onChangeMode(ThemeMode.DARK);
    } else {
      onChangeMode(ThemeMode.LIGHT);
    }
  };

  const handleSupportClick = () => {
    if (USE_INTERCOM) return;

    window.open(SUPPORT_WHATSAPP_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {!downLG && <Search />}
      {/* {!downLG && megaMenu} */}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      {/* TOGGLE THEME */}
      <Box sx={{ ml: 0.5 }}>
        <IconButton
          color="secondary"
          variant="light"
          aria-label="toggle theme"
          onClick={handleModeChange}
          size="large"
          sx={{ color: 'secondary.main', p: 1 }}
        >
          {mode === ThemeMode.DARK ? <Moon variant="Bulk" size={26} /> : <Sun1 variant="Bulk" size={26} />}
        </IconButton>
      </Box>
      <Notification />
      <WhatsNew />
      {localization}
      {!downLG && <FullScreen />}
      {user?.currentPlan?.includes('pro') && (
        <IconButton
          id="btn_custom_intercom"
          color="secondary"
          variant="light"
          aria-label="support chat"
          size="large"
          onClick={handleSupportClick}
          sx={{ color: 'secondary.main', p: 1, ml: 0.5 }}
        >
          <MessageQuestion variant="Bulk" />
        </IconButton>
      )}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
};

export default HeaderContent;
